<template>
    <div id="opportunity-form" class="salesforce-opportunity-form">
        <DxValidationGroup>
            <div class="form-toolbar">
                <ToolbarForm :is-editing="isEditing" @edit-canceled="cancelEdit()" @edit-toggled="startEdit()"
                    @save-clicked="handleSaveClick" />
            </div>

            <DxLoadPanel :show-pane="false" width="auto" container="#opportunity-form"
                :position="{ of: '#opportunity-form' }" />

            <div class="form-cards-container">

                <div class="info-card" :class="{ 'collapsed': !expandedSections.identitate }">
                    <div class="card-section-header" @click="toggleSection('identitate')">
                        <i class="dx-icon-info"></i>
                        <h3>Identitate & Fiscal</h3>
                        <i class="expand-icon"
                            :class="expandedSections.identitate ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'"></i>
                    </div>
                    <div class="card-grid" v-show="expandedSections.identitate">
                        <div class="field-group">
                            <label class="field-label">Nume</label>
                            <FormTextbox v-model="partenerData.Nume" :is-editing="isEditing" :show-label="false"
                                :validators="(defaultValidators as any)" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">CUI</label>
                            <FormTextbox v-model="partenerData.CUI" :is-editing="isEditing" :show-label="false"
                                :validators="(defaultValidators as any)" :buttons="cuiButtons" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Tip Fiscal</label>
                            <DxDropDownBox v-model="partenerData.Fiscal" :data-source="dsParteneriFiscal"
                                display-expr="Nume" value-expr="Cod" :read-only="!isEditing"
                                v-model:opened="isParteneriFiscaliGridBoxOpened" :show-clear-button="true"
                                :drop-down-options="{ width: 450 }">
                                <DxValidator>
                                    <DxRequiredRule message="Tipul Fiscal este obligatoriu" />
                                </DxValidator>
                                <template #content>
                                    <DxDataGrid :data-source="dsParteneriFiscal" :columns="['Nume']"
                                        :hover-state-enabled="true" height="100%"
                                        @selection-changed="onValueSelectedPartenerFiscal">
                                        <DxSelection mode="single" />

                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxSearchPanel :visible="true" placeholder="Caută tip fiscal..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group">
                            <label class="field-label">Cod Caen</label>
                            <FormTextbox v-model="partenerData.Caen" :is-editing="isEditing" :show-label="false"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Nr. Reg. Com</label>
                            <FormTextbox v-model="partenerData.Numar" :is-editing="isEditing" :show-label="false"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Responsabil</label>
                            <DxSelectBox v-if="isEditing" v-model="partenerData.Owner" :data-source="dsUsers"
                                display-expr="Username" value-expr="Username" :show-clear-button="true"
                                :search-enabled="true" />
                            <FormTextbox v-else v-model="partenerData.Owner" :is-editing="false" :show-label="false" />
                        </div>

                        <div class="field-group field-full">
                            <label class="field-label">Cont (IBAN)</label>
                            <FormTextbox v-model="partenerData.Cont" :is-editing="isEditing" :show-label="false"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group field-full">
                            <label class="field-label">Memo</label>
                            <FormTextbox v-model="partenerData.Memo" :is-editing="isEditing" :show-label="false"
                                :validators="optionalValidators" />
                        </div>
                    </div>
                </div>

                <div class="info-card" :class="{ 'collapsed': !expandedSections.social }">
                    <div class="card-section-header" @click="toggleSection('social')">
                        <i class="dx-icon-home"></i>
                        <h3>Sediu Social</h3>
                        <i class="expand-icon"
                            :class="expandedSections.social ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'"></i>
                    </div>
                    <div class="card-grid" v-show="expandedSections.social">

                        <div class="field-group ">
                            <label class="field-label">Strada</label>
                            <FormTextbox v-model="partenerData.Strada" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Nr.</label>
                            <FormTextbox v-model="partenerData.Numarstrada" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Bloc</label>
                            <FormTextbox v-model="partenerData.Bloc" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Scara</label>
                            <FormTextbox v-model="partenerData.Scarabloc" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Etaj</label>
                            <FormTextbox v-model="partenerData.Et" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Ap.</label>
                            <FormTextbox v-model="partenerData.Ap" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Țara</label>
                            <DxDropDownBox v-model="partenerData.TaraID" :data-source="dsTari" display-expr="Nume"
                                value-expr="ID" :read-only="!isEditing" v-model:opened="isTaraGridBoxOpened"
                                :show-clear-button="false" :drop-down-options="{ width: 450 }">
                                <template #content>
                                    <DxDataGrid :data-source="dsTari" :columns="['Nume']" :hover-state-enabled="true"
                                        height="100%" @selection-changed="onValueSelectedTara">
                                        <DxSelection mode="single" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxSearchPanel :visible="true" placeholder="Caută țară..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group">
                            <label class="field-label">Județ</label>
                            <DxDropDownBox v-model="partenerData.JudetID" :data-source="dsJudete" display-expr="Nume"
                                value-expr="ID" :read-only="!isEditing" v-model:opened="isJudetGridBoxOpened"
                                :show-clear-button="false" :drop-down-options="{ width: 450 }">
                                <template #content>
                                    <DxDataGrid :data-source="dsJudete" :columns="['Nume']" :hover-state-enabled="true"
                                        height="100%" @selection-changed="onValueSelectedJudet">
                                        <DxSelection mode="single" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxSearchPanel :visible="true" placeholder="Caută județ..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Localitate</label>
                            <FormTextbox v-model="partenerData.Localitate" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group ">
                            <label class="field-label">Cod Poștal</label>
                            <FormTextbox v-model="partenerData.CP" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group field-full">
                            <label class="field-label">Adresa</label>
                            <FormTextbox v-model="partenerData.Adresa" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                    </div>
                </div>

                <div class="info-card" :class="{ 'collapsed': !expandedSections.DomiciliuFiscal }">
                    <div class="card-section-header" @click="toggleSection('DomiciliuFiscal')">
                        <i class="dx-icon-home"></i>
                        <h3>Domiciliu Fiscal</h3>
                        <i class="expand-icon"
                            :class="expandedSections.DomiciliuFiscal ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'"></i>
                    </div>
                    <div class="card-grid" v-show="expandedSections.DomiciliuFiscal">

                        <div class="field-group ">
                            <label class="field-label">Strada</label>
                            <FormTextbox v-model="partenerData.CStrada" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Nr.</label>
                            <FormTextbox v-model="partenerData.CNumarstrada" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Bloc</label>
                            <FormTextbox v-model="partenerData.CBloc" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Scara</label>
                            <FormTextbox v-model="partenerData.CScarabloc" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Etaj</label>
                            <FormTextbox v-model="partenerData.CEt" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Ap.</label>
                            <FormTextbox v-model="partenerData.CAp" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group ">
                            <label class="field-label">Localitate</label>
                            <FormTextbox v-model="partenerData.CLocalitate" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group">
                            <label class="field-label">Cod Poștal</label>
                            <FormTextbox v-model="partenerData.CCP" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group field-full">
                            <label class="field-label">Adresa</label>
                            <FormTextbox v-model="partenerData.CAdresa" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                    </div>
                </div>


                <div class="info-card" :class="{ 'collapsed': !expandedSections.financiar }">
                    <div class="card-section-header" @click="toggleSection('financiar')">
                        <i class="dx-icon-home"></i>
                        <h3>Configurare Financiară & Comericală</h3>
                        <i class="expand-icon"
                            :class="expandedSections.financiar ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'"></i>
                    </div>
                    <div class="card-grid" v-show="expandedSections.financiar">

                        <div class="field-group">
                            <label class="field-label">Banca (Internă)</label>
                            <DxDropDownBox v-model="partenerData.Banca" :data-source="dsBanci" display-expr="Nume"
                                value-expr="Nume" :read-only="!isEditing" v-model:opened="isBanciGridBoxOpened"
                                :show-clear-button="true" :drop-down-options="{ width: 450 }">

                                <template #content>
                                    <DxDataGrid :data-source="dsBanci" :columns="['Nume']" :hover-state-enabled="true"
                                        height="100%" @selection-changed="onValueSelectedBanca">
                                        <DxSelection mode="single" />

                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxSearchPanel :visible="true" placeholder="Caută bancă..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group">
                            <label class="field-label">Valută</label>
                            <DxDropDownBox v-model="partenerData.ValutaID" :data-source="dsValute" display-expr="Simbol"
                                value-expr="Id" :read-only="!isEditing" v-model:opened="isValuteGridBoxOpened"
                                :show-clear-button="true" :drop-down-options="{ width: 450 }">

                                <template #content>
                                    <DxDataGrid :data-source="dsValute" :columns="['Simbol']"
                                        :hover-state-enabled="true" height="100%"
                                        @selection-changed="onValueSelectedValuta">
                                        <DxSelection mode="single" />

                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxSearchPanel :visible="true" placeholder="Caută valuta..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Capital Social</label>
                            <FormTextbox v-model="partenerData.CapitalSocial" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Cifra Afacere</label>
                            <FormTextbox v-model="partenerData.CifraAfacere" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Nr. Angajati</label>
                            <FormTextbox v-model="partenerData.NrAngajati" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Grup *</label>
                            <DxDropDownBox v-model="partenerData.GrupID" :data-source="dsGrupuri" display-expr="Nume"
                                value-expr="Id" :read-only="!isEditing" v-model:opened="isGrupuriGridBoxOpened"
                                :is-valid="!grupError" :show-clear-button="true" :drop-down-options="{ width: 450 }">

                                <template #content>
                                    <DxDataGrid :data-source="dsGrupuri" :columns="['Nume']" :hover-state-enabled="true"
                                        height="100%" @selection-changed="onValueSelectedGrup">
                                        <DxSelection mode="single" />

                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxSearchPanel :visible="true" placeholder="Caută grup..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group">
                            <label class="field-label">Zona *</label>
                            <DxDropDownBox v-model="partenerData.ZonaID" :data-source="dsZone" display-expr="Nume"
                                value-expr="Id" :read-only="!isEditing" v-model:opened="isZoneGridBoxOpened"
                                :is-valid="!zonaError" :show-clear-button="true" :drop-down-options="{ width: 450 }">

                                <template #content>
                                    <DxDataGrid :data-source="dsZone" :columns="['Nume']" :hover-state-enabled="true"
                                        height="100%" @selection-changed="onValueSelectedZone">
                                        <DxSelection mode="single" />

                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxSearchPanel :visible="true" placeholder="Caută zonă..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Adaos Pret</label>
                            <FormTextbox v-model="partenerData.AdaosPret" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Termen de plată</label>
                            <FormTextbox v-model="partenerData.Scadenta" :is-editing="isEditing && canEditLimiteCredit"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Limita de credit</label>
                            <FormTextbox v-model="partenerData.CreditLimita" :is-editing="isEditing && canEditLimiteCredit"
                                :validators="optionalValidators" />
                        </div>

                    </div>
                </div>

                <div class="info-card" :class="{ 'collapsed': !expandedSections.contact }">
                    <div class="card-section-header" @click="toggleSection('contact')">
                        <i class="dx-icon-home"></i>
                        <h3>Contact & Diverse</h3>
                        <i class="expand-icon"
                            :class="expandedSections.contact ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'"></i>
                    </div>
                    <div class="card-grid" v-show="expandedSections.contact">

                        <div class="field-group ">
                            <label class="field-label">Telefon</label>
                            <FormTextbox v-model="partenerData.Tel" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Fax</label>
                            <FormTextbox v-model="partenerData.Fax" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Email</label>
                            <FormTextbox v-model="partenerData.Email" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Director</label>
                            <FormTextbox v-model="partenerData.Director" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">WWW</label>
                            <FormTextbox v-model="partenerData.www" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group field-full ">
                            <label class="field-label">Observatii</label>
                            <FormTextbox v-model="partenerData.Observatii" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>


                    </div>
                </div>

                <div class="info-card" :class="{ 'collapsed': !expandedSections.systemFlags }">
                    <div class="card-section-header" @click="toggleSection('systemFlags')">
                        <i class="dx-icon-home"></i>
                        <h3>System Flags</h3>
                        <i class="expand-icon"
                            :class="expandedSections.systemFlags ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'"></i>
                    </div>
                    <div class="card-grid" v-show="expandedSections.systemFlags">

                        <div class="field-group">
                            <label class="field-label">TVA la Încasare</label>
                            <DxCheckBox v-model="partenerData.AplicaTVAlaIncasare" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Regim Special TVA</label>
                            <DxCheckBox v-model="partenerData.RegimSpecialTVA" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group ">
                            <label class="field-label">Intern</label>
                            <DxCheckBox v-model="partenerData.Intern" :read-only="!isEditing"
                                :validators="optionalValidators" @value-changed="handleInternChange" />
                        </div>
                        <div class="field-group ">
                            <label class="field-label">Extern Non UE</label>
                            <DxCheckBox v-model="partenerData.Extern" :read-only="!isEditing"
                                :validators="optionalValidators" @value-changed="handleExternChange" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Extern UE</label>
                            <DxCheckBox v-model="partenerData.ExternUE" :read-only="!isEditing"
                                :validators="optionalValidators" @value-changed="handleExternUEChange" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Client</label>
                            <DxCheckBox v-model="partenerData.Client" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Furnizor</label>
                            <DxCheckBox v-model="partenerData.Furnizor" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Activ</label>
                            <DxCheckBox v-model="partenerData.Activ" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Split TVA</label>
                            <DxCheckBox v-model="partenerData.AplicaTvaDefalcat" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group ">
                            <label class="field-label">Fara Scadenta</label>
                            <DxCheckBox v-model="partenerData.faraScadenta" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group ">
                            <label class="field-label">Calculez Penalitati</label>
                            <DxCheckBox v-model="partenerData.CalculezPenalitati" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group ">
                            <label class="field-label">Litigiu</label>
                            <DxCheckBox v-model="partenerData.Litigiu" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>

                    </div>
                </div>

            </div>
        </DxValidationGroup>
    </div>
</template>

<script lang="ts">
import notify from 'devextreme/ui/notify';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { defineComponent } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxLookup from "devextreme-vue/lookup"
import {
    DxForm,
    DxItem as DxFormItem,
    DxGroupItem as DxFormGroupItem,
    DxColCountByScreen,
} from 'devextreme-vue/form';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { DxValidator, DxRequiredRule } from 'devextreme-vue/validator';
import { DxValidationGroup } from 'devextreme-vue/validation-group';
import DxLoadPanel from 'devextreme-vue/load-panel';
import ToolbarForm from '@/components/utils/toolbar-form.vue';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '../../settings/appSettings'
import FormTextbox from '@/components/utils/form-textbox.vue';
import DxSelectBox from "devextreme-vue/select-box"
import DxDateBox from "devextreme-vue/date-box"
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
    DxDataGrid,
    DxPaging,
    DxSelection,
    DxSearchPanel,
    DxFilterRow,
} from 'devextreme-vue/data-grid';
import PAR_Parteneri from '@/services/PAR/PAR_Parteneri';
import AUTH_Users from '@/services/AUTH/AUTH_Users';
import AnafService from '@/services/AnafService';

// Litere mici — GUID-uri serializate de .NET sunt lowercase, comparate case-sensitive
// de DevExtreme; aceleași constante ca în PopupAdaugareDetaliu.vue (Comenzi).
const GRUP_PERSOANA_FIZICA_ID = 'd41f9383-09b5-42c7-a33c-5050a438752a';
const GRUP_SMB_ID = '646a5caa-f34a-43ee-aebb-f1509b3e005e';

export default defineComponent({
    components: {
        DxForm,
        DxFormItem,
        DxFormGroupItem,
        DxColCountByScreen,
        DxNumberBox,
        DxValidator,
        DxRequiredRule,
        DxValidationGroup,
        DxLoadPanel,
        FormTextbox,
        ToolbarForm,
        DxButton,
        DxSelectBox,
        DxLookup,
        DxDateBox,
        DxDropDownBox,
        DxDataGrid,
        DxPaging,
        DxSelection,
        DxSearchPanel,
        DxFilterRow,
        DxCheckBox
    },
    props: {
        partenerData: {
            type: Object,
            required: true
        },
        isEditing: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            dsCampanii: {} as any,
            isCampanieGridBoxOpened: false,
            sCampanie: null,
            dsSales: null,
            isEditing: false,
            canEditLimiteCredit: false,
            grupError: false,
            zonaError: false,
            isParteneriGridBoxOpened: false,
            dsParteneri: {} as any,
            sPartener: null,
            sIndustrie: null,
            dsIndustrii: {} as any,
            isIndustrieGridBoxOpened: false,
            dsContacts: {} as any,
            sContact: null,
            isContacteGridBoxOpened: false,
            expandedSections: {
                identitate: true,
                social: true,
                DomiciliuFiscal: false,
                StatusFiscal: false,
                financiar: false,
                comercial: false,
                contact: false,
                systemFlags: false
            },
            isSursaGridBoxOpened: false,
            isTaraGridBoxOpened: false,
            sTara: null as string | null,
            isJudetGridBoxOpened: false,
            isLocalitateGridBoxOpened: false,
            sSalesSources: null,
            isParteneriFiscaliGridBoxOpened: false,
            dsParteneriFiscal: {} as any,
            sParteneriFiscal: null,
            isBanciGridBoxOpened: false,
            dsBanci: {} as ODataStore,
            sBanci: null,
            dsSalesSources: {} as any,
            dsTari: {} as any,
            dsValute: {} as any,
            sValute: null,
            isValuteGridBoxOpened: false,
            isGrupuriGridBoxOpened: false,
            sGrupuri: null,
            isZoneGridBoxOpened: false,
            sZone: null,
            dsZone: {} as any,
            dsGrupuri: {} as any,
            dsJudete: {} as any,
            dsLocalitati: {} as any,
            dsUsers: [] as any[],
            metodaContact: ['Telefonic', 'Email'],
            // Coloanele bool? din PAR_Parteneri pot veni NULL din DB pe înregistrări vechi —
            // normalizate la false imediat la afișare (watch partenerData mai jos), ca bifele din
            // System Flags să nu rămână niciodată în stare nedeterminată și să nu se retrimită null.
            systemFlagsBool: [
                'Client', 'Furnizor', 'Litigiu', 'Extern', 'Intern', 'faraScadenta',
                'AplicaTVAlaIncasare', 'Activ', 'CalculezPenalitati', 'ExternUE',
                'RegimSpecialTVA', 'AplicaTvaDefalcat',
            ],
        }
    },
    watch: {
        partenerData: {
            immediate: true,
            handler(val) {
                if (!val) return;
                this.systemFlagsBool.forEach((field) => {
                    if (val[field] == null) val[field] = false;
                });
            },
        },
        'partenerData.Fiscal': function (newVal) {
            if (newVal === 'F') {
                this.partenerData.GrupID = GRUP_PERSOANA_FIZICA_ID;
            } else if (newVal === 'P' || newVal === 'N') {
                this.partenerData.GrupID = GRUP_SMB_ID;
            }
        },
    },
    computed: {
        defaultValidators() {
            return [{ type: 'required', message: 'Acest câmp este obligatoriu' }];
        },
        optionalValidators() {
            return [];
        },
        emailValidators() {
            if (this.partenerData.MetodaContact === 'Email') {
                return [
                    { type: 'required', message: 'Email-ul este obligatoriu' },
                    { type: 'email', message: 'Email invalid' }
                ];
            }
            return [];
        },
        phoneValidators() {
            if (this.partenerData.MetodaContact === 'Telefonic') {
                return [{ type: 'required', message: 'Telefonul este obligatoriu' }];
            }
            return [];
        },
        cuiButtons() {
            if (!this.isEditing) return [];
            return [{
                name: 'searchAnaf',
                location: 'after',
                options: {
                    icon: 'search',
                    width: 26,
                    height: 26,
                    type: 'default',
                    hint: 'Caută în ANAF',
                    onClick: () => this.onSearchAnaf()
                }
            }];
        }
    },
    methods: {
        createODataContext() {
            this.dsValute = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Simbol',
                ],

            });
            this.dsZone = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Zone',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],

            });
            this.dsGrupuri = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_Grupuri',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                    'Cod'
                ],
                sort: [
                    { selector: 'Cod', desc: false }
                ]

            });
            this.dsParteneriFiscal = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_ParteneriFiscal',
                    // key: 'ID',
                    // keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'Cod',
                    'Nume',
                ],

            });
            this.dsBanci = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_BanciParteneri',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],

            });
            this.dsContacts = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Contacts',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['ID', 'Nume'],
            });



            this.dsSales = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                }
            });

            this.dsParteneri = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['ID', 'Nume'],
            });

            this.dsSalesSources = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_SalesSources',
                    key: 'ID',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['ID', 'Nume'],
            });

            this.dsCampanii = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareCampaniiMarketing',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['ID', 'Denumire'],
            });
            this.dsTari = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });
            this.dsJudete = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });
            this.dsLocalitati = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Localitati',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Localitate',
                ],

            });
        },
        onValueSelectedZone(e) {
            const selected = e.selectedRowsData[0];
            this.partenerData.ZonaID = selected ? selected.Id : null;
            this.isZoneGridBoxOpened = false;
            this.zonaError = false;
        },
        onValueSelectedGrup(e) {
            const selected = e.selectedRowsData[0];
            this.partenerData.GrupID = selected ? selected.Id : null;
            this.isGrupuriGridBoxOpened = false;
            this.grupError = false;
        },
        onValueSelectedValuta(e) {
            const selected = e.selectedRowsData[0];
            this.partenerData.ValutaID = selected ? selected.Id : null;
            this.isValuteGridBoxOpened = false;
        },
        onValueSelectedPartenerFiscal(e) {
            const selected = e.selectedRowsData[0];
            this.partenerData.Fiscal = selected ? selected.Cod : null;
            this.isParteneriFiscaliGridBoxOpened = false;

        },
        onValueSelectedBanca(e) {
            const selected = e.selectedRowsData[0];
            this.partenerData.Banca = selected ? selected.Nume : null;
            this.isBanciGridBoxOpened = false;

        },
        onValueSelectedTara(e) {
            this.isTaraGridBoxOpened = false;
            const selectedTaraId = e.selectedRowKeys[0] || null;

            // SCHIMBĂ AICI: folosește partenerData (ca în HTML) în loc de contactData
            if (this.partenerData) {
                this.partenerData.TaraID = selectedTaraId;
            }

            this.sTara = selectedTaraId;

            // Filtrarea județelor rămâne valabilă
            if (this.dsJudete) {
                const _filter = selectedTaraId ? ["TaraID", "=", selectedTaraId] : null;
                this.dsJudete.filter(_filter);
                this.dsJudete.load();
            }
        },
        onValueSelectedJudet(e) {
            this.isJudetGridBoxOpened = false;

            const selectedJudetId = e.selectedRowKeys[0] || null;

            if (this.partenerData) {
                this.partenerData.JudetID = selectedJudetId;
            }

            const _filter = selectedJudetId ? ["JudetID", "=", selectedJudetId] : null;

            this.dsLocalitati.filter(_filter);
            this.dsLocalitati.load();
        },
        onValueSelectedLocalitate(e) {
            this.isLocalitateGridBoxOpened = false;

            // Luăm ID-ul selectat
            const selectedLocalitateId = e.selectedRowKeys[0] || null;

            // Salvează în obiectul corect (cel folosit în v-model-ul de la DropDownBox)
            if (this.partenerData) {
                this.partenerData.LocalitateID = selectedLocalitateId;
            } else {
                console.error("Obiectul partenerData nu este inițializat!");
            }
        },
        onValueSelectedPartener(e) {
            const selected = e.selectedRowsData[0];
            this.partenerData.AccountID = selected ? selected.ID : null;
            this.isParteneriGridBoxOpened = false;
            const _filter = selected ? ["AccountId", "=", selected.ID] : null;
            this.dsContacts.filter(_filter);
            this.dsContacts.load();
        },
        onValueSelectedCampanie(e) {
            this.isCampanieGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sCampanie = e.selectedRowKeys[0];
            } else {
                this.sCampanie = null;
            }
            this.formData.CampanieID = this.sCampanie;
        },
        onValueSelectedContact(e) {
            this.isContacteGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sContact = e.selectedRowKeys[0];
            } else {
                this.sContact = null;
            }
            this.formData.ContactID = this.sContact;
        },
        onValueSelectedIndustrie(e) {
            this.isIndustrieGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sIndustrie = e.selectedRowKeys[0];
            } else {
                this.sIndustrie = null;
            }
            this.formData.IndustrieID = this.sIndustrie;
        },
        onValueSelectedSursa(e) {
            this.isSursaGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sSalesSources = e.selectedRowKeys[0];
            } else {
                this.sSalesSources = null;
            }
            this.formData.SursaID = this.sSalesSources;
        },
        toggleSection(section: string) {
            this.expandedSections[section] = !this.expandedSections[section];
        },
        handleInternChange(e) {
            if (e.value) {
                this.partenerData.Extern = false;
                this.partenerData.ExternUE = false;
            }
        },
        handleExternChange(e) {
            if (e.value) {
                this.partenerData.Intern = false;
                this.partenerData.ExternUE = false;
            }
        },
        handleExternUEChange(e) {
            if (e.value) {
                this.partenerData.Intern = false;
                this.partenerData.Extern = false;
            }
        },
        startEdit() {
            this.isEditing = true;
        },
        cancelEdit() {
            this.isEditing = false;
        },
        handleSaveClick({ validationGroup }) {
            const result = validationGroup.validate();
            if (!result.isValid) {
                console.warn('Formular invalid:', result);
                return;
            }

            this.grupError = !this.partenerData.GrupID;
            this.zonaError = !this.partenerData.ZonaID;
            if (this.grupError || this.zonaError) {
                const msg = this.grupError && this.zonaError
                    ? 'Completați câmpurile obligatorii "Grup" și "Zona"!'
                    : this.grupError
                        ? 'Completați câmpul obligatoriu "Grup"!'
                        : 'Completați câmpul obligatoriu "Zona"!';
                notify(msg, 'error', 2000);
                return;
            }

            const id = this.partenerData?.ID;
            if (!id) {
                console.warn('Lipsește ID-ul partenerului.');
                return;
            }

            // 1) Clone + coerciții de tip
            const payload = {
                ...this.partenerData,

                AdaosPret: this.partenerData.AdaosPret !== '' && this.partenerData.AdaosPret != null
                    ? Number(this.partenerData.AdaosPret)
                    : null,

                Scadenta: this.partenerData.Scadenta !== '' && this.partenerData.Scadenta != null
                    ? parseInt(this.partenerData.Scadenta, 10)
                    : null,

                CreditLimita: this.partenerData.CreditLimita !== '' && this.partenerData.CreditLimita != null
                    ? Number(this.partenerData.CreditLimita)
                    : null,

                CapitalSocial: this.partenerData.CapitalSocial !== '' && this.partenerData.CapitalSocial != null
                    ? Number(this.partenerData.CapitalSocial)
                    : null,

                CifraAfacere: this.partenerData.CifraAfacere !== '' && this.partenerData.CifraAfacere != null
                    ? Number(this.partenerData.CifraAfacere)
                    : null,
            };

            // 2) Nu trimite chestii pe care serverul le decide
            delete payload.ID; // ID îl dai în URL
            delete payload.UserCreare;
            delete payload.DataCreare;
            delete payload.UserModificare;
            delete payload.DataModificare;

            console.log('Salvez payload:', payload);

            PAR_Parteneri
                .update(id, payload)
                .then(() => {
                    console.log('Salvare reușită!');
                    this.$emit('saved', { ...this.partenerData, ...payload, ID: id });
                    this.isEditing = false;
                })
                .catch((err) => {
                    const status = err?.response?.status;
                    const data = err?.response?.data;

                    if (status === 409 && data?.code === 'CUI_EXISTS') {
                        notify(data.message || 'Partenerul cu acest CUI există deja!', 'error', 2000);
                        return;
                    }

                    console.error('Eroare la salvare:', err);
                    notify('Eroare la salvare!', 'error', 2000);
                });

        },
        // Normalizare diacritice + case pentru potrivirea numelui de județ primit de la ANAF
        // (ex: "BIHOR") cu nomenclatorul ERP_Judete (ex: "Bihor").
        normalizeazaText(text) {
            return String(text ?? "")
                .normalize("NFD")
                .replace(/[̀-ͯ]/g, "")
                .toUpperCase()
                .trim();
        },
        async cautaJudetDupaNume(nume, taraId) {
            if (!nume || !taraId) return null;
            const store = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete', key: 'ID', keyType: 'Guid', version: 4,
                fieldTypes: { TaraID: 'Guid' },
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                },
            });
            const rows = await store.load({ filter: ['TaraID', '=', taraId], select: ['ID', 'Nume'] });
            const target = this.normalizeazaText(nume);
            return rows.find(j => this.normalizeazaText(j.Nume) === target) ?? null;
        },
        async onSearchAnaf() {
            const cuiRaw = this.partenerData.CUI;
            if (!cuiRaw) {
                notify("Te rog introdu un CUI valid", "warning", 2000);
                return;
            }

            const cui = Number(String(cuiRaw).replace(/\D/g, ""));
            if (!cui) {
                notify("Te rog introdu un CUI valid", "warning", 2000);
                return;
            }

            try {
                // --- 1. APEL DATE GENERALE (Identitate, TVA, Sediu) ---
                const anafResult = await AnafService.getCompanyDetails(cui);

                if (!anafResult) {
                    notify("CUI-ul nu a fost găsit sau nu există date publice.", "warning", 3000);
                    return;
                }

                const dg = anafResult.date_generale;
                const ss = anafResult.adresa_sediu_social;
                const df = anafResult.adresa_domiciliu_fiscal;
                const formaOrg = String(dg?.forma_organizare ?? "").toUpperCase().trim();
                const scpTVA = Boolean(anafResult?.inregistrare_scop_Tva?.scpTVA);

                // Stabilire regim fiscal (F/P/N)
                let fiscal = null;
                if (formaOrg.includes("PERSOANA FIZICA")) {
                    fiscal = "F";
                } else if (formaOrg.includes("PERSOANA JURIDICA")) {
                    fiscal = scpTVA ? "P" : "N";
                }
                if (fiscal) this.partenerData.Fiscal = fiscal;

                // Mapare date de bază
                // La fel ca în legacy (PAR_ParteneriForm.cs): CUI cu prefix "RO" doar dacă firma e
                // înregistrată ca plătitor de TVA la data căutării, altfel fără prefix.
                this.partenerData.CUI = dg.cui ? (scpTVA ? `RO${dg.cui}` : String(dg.cui)) : this.partenerData.CUI;
                this.partenerData.Nume = dg.denumire ?? this.partenerData.Nume;
                this.partenerData.Numar = dg.nrRegCom ?? this.partenerData.Numar;
                this.partenerData.Caen = dg.cod_CAEN ?? this.partenerData.Caen;

                // Adresa Corespondenta
                this.partenerData.CAdresa = dg.adresa ?? this.partenerData.CAdresa;

                // Adresa Sediu Social
                if (ss) {
                    this.partenerData.Localitate = ss.sdenumire_Localitate ?? this.partenerData.Localitate;
                    this.partenerData.Strada = ss.sdenumire_Strada ?? this.partenerData.Strada;
                    this.partenerData.Numarstrada = ss.snumar_Strada ?? this.partenerData.Numarstrada;
                    this.partenerData.CP = ss.scod_Postal ?? this.partenerData.CP;

                    // ANAF întoarce doar numele județului (ex: "BIHOR"), nu ID-ul din nomenclatorul
                    // intern ERP_Judete — se caută prin nume normalizat (fără diacritice/case).
                    if (ss.sdenumire_Judet && this.partenerData.TaraID) {
                        const judet = await this.cautaJudetDupaNume(ss.sdenumire_Judet, this.partenerData.TaraID);
                        if (judet) {
                            this.partenerData.JudetID = judet.ID;
                        } else {
                            console.warn(`Județul „${ss.sdenumire_Judet}" nu a fost găsit în nomenclator — selectează-l manual.`);
                        }
                    }
                }

                // Domiciliu Fiscal — completează câmpurile structurate (formularul nu are un
                // dropdown separat de Județ pentru domiciliul fiscal, doar text liber).
                if (df) {
                    this.partenerData.CLocalitate = df.ddenumire_Localitate ?? this.partenerData.CLocalitate;
                    this.partenerData.CStrada = df.ddenumire_Strada ?? this.partenerData.CStrada;
                    this.partenerData.CNumarstrada = df.dnumar_Strada ?? this.partenerData.CNumarstrada;
                    this.partenerData.CCP = df.dcod_Postal ?? this.partenerData.CCP;
                }

                this.partenerData.Tel = dg.telefon ?? this.partenerData.Tel;

                if (dg.iban) this.partenerData.Cont = dg.iban;

                this.partenerData.AplicaTvaDefalcat = anafResult.inregistrare_SplitTVA?.statusSplitTVA ?? false;
                if (anafResult.stare_inactiv?.statusInactivi) {
                    this.partenerData.Activ = false;
                    notify("Atenție: firma este marcată ca INACTIVĂ la ANAF!", "warning", 4000);
                }

                // Logica TVA
                this.partenerData.AplicaTVAlaIncasare = anafResult.inregistrare_RTVAI?.statusTvaIncasare ?? false;

                const extras = [];
                if (dg.stare_inregistrare) extras.push(`Stare: ${dg.stare_inregistrare}`);
                if (typeof dg.statusRO_e_Factura === "boolean") extras.push(`RO e-Factura: ${dg.statusRO_e_Factura ? "DA" : "NU"}`);

                // --- 2. APEL DATE FINANCIARE (Bilanț pentru CifraAfacere și NumarAngajati) ---
                try {
                    // Încercăm anul 2024, cu fallback pe 2023 dacă nu sunt date depuse încă
                    let finData = await AnafService.getFinancialData(cui, 2024);
                    if (!finData || !finData.i || finData.i.length === 0) {
                        finData = await AnafService.getFinancialData(cui, 2023);
                    }

                    if (finData && finData.i) {
                        const indicatori = finData.i;

                        // 1. Căutăm Cifra de Afaceri
                        const caRow = indicatori.find((item: any) => {
                            const nume = item.val_den_indicator.toUpperCase();
                            return nume.includes("CIFRA DE AFACERI NET") || nume === "VENITURI TOTALE";
                        });

                        // 2. Căutăm Numărul de Angajați
                        const angRow = indicatori.find((item: any) => {
                            const nume = item.val_den_indicator.toUpperCase();
                            return nume.includes("NUMAR MEDIU DE SALARIATI") || nume.includes("NR. MEDIU SALARIATI");
                        });

                        // Populare coloane
                        if (caRow) {
                            this.partenerData.CifraAfacere = caRow.val_indicator;
                            extras.push(`CA: ${caRow.val_indicator.toLocaleString()}`);
                        }

                        if (angRow) {
                            this.partenerData.NrAngajati = angRow.val_indicator;
                            extras.push(`Angajați: ${angRow.val_indicator}`);
                        }
                    }
                } catch (finError) {
                    console.warn("Datele financiare nu au putut fi încărcate.", finError);
                }

                // Finalizare Memo
                if (extras.length) {
                    const prev = this.partenerData.Memo ? String(this.partenerData.Memo).trim() + "\n" : "";
                    this.partenerData.Memo = prev + extras.join(" | ");
                }

                notify("Datele au fost preluate cu succes!", "success", 2000);

            } catch (error) {
                console.error(error);
                notify("Eroare la interogarea ANAF", "error", 4000);
            }
        },
        getUsers() {
            AUTH_Users.get().then((response: any) => {
                this.dsUsers = response.data;
            }).catch((error: any) => {
                console.error(error);
            });
        },

    },
    mounted() {
        this.createODataContext();
        this.getUsers();
        PAR_Parteneri.getDrepturiMele()
            .then((res: any) => { this.canEditLimiteCredit = res.data?.EditareLimiteCredit === true; })
            .catch(() => { this.canEditLimiteCredit = false; });
    },
});
</script>

<style scoped lang="scss">
.salesforce-opportunity-form {
    position: relative;
}

.form-toolbar {
    margin-bottom: 0.25rem;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 0.4rem;
    border-bottom: 1px solid #e5e7eb;
}

.form-cards-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: start;
    gap: 0.5rem;
}

/* Info Card Styling */
.info-card {
    background: white;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.card-section-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 1rem;
    background: linear-gradient(to bottom, #fafafa 0%, #f5f5f5 100%);
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;

    &:hover {
        background: linear-gradient(to bottom, #f5f5f5 0%, #efefef 100%);
    }

    i {
        font-size: 18px;
        color: #6b7280;
    }

    h3 {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
        color: #111827;
        letter-spacing: -0.01em;
        flex: 1;
    }

    .expand-icon {
        font-size: 14px;
        color: #9ca3af;
        transition: transform 0.2s ease;
        margin-left: auto;
    }
}

.info-card.collapsed {
    .card-section-header {
        border-bottom: none;
    }
}

.card-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.6rem;
    padding: 0.75rem;
    transition: all 0.3s ease;
}

.field-group {
    display: flex;
    flex-direction: column;


    &.full-width {
        grid-column: 1 / -1;
    }
}

.field-label {
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    margin-bottom: 2px;
}

/* DevExtreme Input Overrides */
::v-deep(.dx-texteditor) {
    border-radius: 4px;
    border-color: #d1d5db;
    background: white;

    &.dx-state-readonly {
        background: #f9fafb;
        border-color: #e5e7eb;
    }

    &.dx-state-focused {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &.dx-state-hover:not(.dx-state-readonly) {
        border-color: #9ca3af;
    }
}

::v-deep(.dx-texteditor-input) {
    padding: 8px 12px;
    font-size: 14px;
    color: #111827;
    min-height: 38px;
}

::v-deep(.dx-dropdowneditor-button) {
    border-left: 1px solid #e5e7eb;
}

/* Responsive */
@media (max-width: 768px) {
    .form-cards-container {
        grid-template-columns: 1fr;
    }

    .card-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
        padding: 1rem;
    }

    .field-group.full-width {
        grid-column: 1;
    }
}

.field-full {
    grid-column: 1 / -1;
}
</style>
